import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { SiteMapUrl } from 'src/app/core/_enums/sitemap.url';
import { Indicator } from 'src/app/core/_models/indicator';
import { Project } from 'src/app/core/_models/project';
import { Scenario } from 'src/app/core/_models/scenario';
import { Solution } from 'src/app/core/_models/solution';
import { AuthService } from 'src/app/core/_services/auth.service';
import { ProjectService } from 'src/app/core/_services/project.service';
import { SpinnerOverlayService } from 'src/app/core/_services/spinner.overlay.service';
import { DialogOverviewComponent } from '../shared/dialog-overview/dialog-overview.component';
import { DialogScenarioComponent } from '../shared/dialog-scenario/dialog-scenario.component';
import { DialogSolutionScenarioComponent } from '../shared/dialog-solution-scenario/dialog-solution-scenario.component';
import { SnackbarTypes } from 'src/app/core/_enums/snackbar.types';
import { SnackbarService } from 'src/app/core/_services/snackbar.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-scenario-project',
  templateUrl: './scenario-project.component.html',
  styleUrls: ['./scenario-project.component.scss']
})
export class ScenarioProjectComponent implements OnInit {
  @Input() biodeversityIndicators!: boolean;
  projectId!: string;
  scenarios!: Scenario[];
  indicators!: Indicator[];

  constructor(
    private matDialog: MatDialog,
    private projectService: ProjectService,
    private authservice: AuthService,
    private activeRoute: ActivatedRoute,
    private spinnerService: SpinnerOverlayService,
    private snackbarService: SnackbarService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.activeRoute.params.subscribe((params) => {
      if (params.id && params.id != '0') {
        this.projectId = params.id;
        this.projectService.getScenarioByProjectId(params.id).subscribe((scenarios) => {
          this.scenarios = scenarios;
        });
      }
    });

    this.projectService.getIndicators().subscribe((arr: Indicator[]) => {
      this.indicators = arr;
    });
  }

  editScenario(item: Scenario) {
    const dialogRef = this.matDialog.open(DialogScenarioComponent, {
      data: {
        indicators: item.indicatorSelected,
        scenario: item
      }
    });

    dialogRef.afterClosed().subscribe(async (data) => {
      if (data?.scenario) {
        try {
          let payload = JSON.parse(JSON.stringify(data.scenario));
          payload.indicatorSelected = data.indicators?.filter((item: Indicator) => item.isChecked == true);
          let resp = await this.projectService.updateScenario(payload);
          item = Object.assign(item, resp);
        } catch (error) {
          this.snackbarService.open(SnackbarTypes.error);
        }
      }
    });
  }

  deleteScenario(arr: Scenario[], i: number) {
    let title = this.translate.instant('confirm_delete_scenario');

    const dialogRef = this.matDialog.open(DialogOverviewComponent, {
      data: { title: title }
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        let scenarioId = arr[i]?.scenarioId;
        if (scenarioId) {
          try {
            await this.projectService.deleteScenario(scenarioId);
            arr.splice(i, 1);
          } catch (error) {
            this.snackbarService.open(SnackbarTypes.error);
          }
        }
      }
    });
  }

  async editRank(scenario: Scenario, index: number, new_index: number) {
    let solutions = scenario?.solutions;
    if (solutions) {
      this.spinnerService.show();
      solutions.splice(new_index, 0, solutions.splice(index, 1)[0]);
      var rank = solutions[new_index].rank;
      solutions[new_index].rank = solutions[index].rank;
      solutions[index].rank = rank;

      try {
        let res = await this.projectService.editRank(scenario?.scenarioId, solutions);
        if (res) {
          this.spinnerService.hide();
        } else {
          this.spinnerService.hide();
          this.snackbarService.open(SnackbarTypes.error);
        }
      } catch (error) {
        this.spinnerService.hide();
        this.snackbarService.open(SnackbarTypes.error);
      }
    }
  }

  // Ajouter une solution dans le scénario
  addSolution(item: Scenario) {
    this.projectService.getProjectsListForScenario(this.projectId).subscribe((projects: Project[]) => {
      const dialogRef = this.matDialog.open(DialogSolutionScenarioComponent, {
        data: {
          projects: projects,
          currentSolution: {}
        }
      });

      dialogRef.afterClosed().subscribe(async (solution: Solution) => {
        if (solution) {
          try {
            if (!item?.solutions) {
              item.solutions = [];
            }
            let rank = item.solutions?.length ? item.solutions?.length : 0;
            let response: Solution = await this.projectService.addSolutionScenario(item.scenarioId, solution, rank);
            response.rank = rank;
            item.solutions?.splice(rank, 0, response);
          } catch (error) {
            this.snackbarService.open(SnackbarTypes.error);
          }
        }
      });
    });
  }

  deleteSolution(i: number, scenario?: Scenario, currentSolution?: Solution) {
    let title = this.translate.instant('confirm_delete_solution');

    const dialogRef = this.matDialog.open(DialogOverviewComponent, {
      data: { title: title }
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result && scenario?.solutions) {
        try {
          let solutions = scenario?.solutions;
          await this.projectService.deleteSolutionScenario(scenario?.scenarioId, currentSolution?.id, currentSolution?.rank);
          solutions.splice(i, 1);
        } catch (error) {
          this.snackbarService.open(SnackbarTypes.error);
        }
      }
    });
  }

  addScenario(arr: Scenario[]) {
    this.checkIndicators();
    const dialogRef = this.matDialog.open(DialogScenarioComponent, {
      data: {
        indicators: this?.indicators,
        scenario: { projectId: this.projectId, isHybrid: false }
      }
    });

    dialogRef.afterClosed().subscribe(async (data) => {
      if (data?.scenario) {
        try {
          let payload = JSON.parse(JSON.stringify(data.scenario));
          payload.indicatorSelected = data.indicators?.filter((item: Indicator) => item.isChecked == true);
          let res = await this.projectService.addScenario(payload);
          res.indicatorSelected = data.indicators;
          arr.push(res);
        } catch (error) {
          this.snackbarService.open(SnackbarTypes.error);
        }
      }
    });
  }

  clickSynthese(scenario?: Scenario) {
    this.router.navigate([SiteMapUrl.MenuProject, SiteMapUrl.MenuSynthese, scenario?.scenarioId], { state: { scenario: scenario, projectId: scenario?.projectId, perimeterId: this.authservice.roleValue.perimeterId } });
  }

  checkIndicators() {
    if (this.indicators) {
      this.indicators = this.indicators?.map((item: Indicator) => {
        if ((item.code == 'PE' || item.code == 'PB') && !this.biodeversityIndicators) {
          item.isChecked = false;
          return item;
        }

        item.isChecked = true;
        return item;
      });
    }
  }
}
